import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common components
import { Form, Button, TextInput } from "src/Components";
// Types
import { IRemainingDayConfig } from "src/Interfaces/automaticMarketMaking";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Requests
import {
  getRemainingDayConfig,
  setRemainingDayConfig,
} from "src/Requests/automaticMarketMaking";

interface Props {
  onSuccess: () => void;
  onClose: () => void;
}
const RemainingDayConfigModal: React.FC<Props> = (props) => {
  // local store
  const [config, setConfig] = React.useState({} as IRemainingDayConfig);

  React.useEffect(() => {
    getRemainingDayConfig()
      .then((res) => {
        setConfig(res);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setConfig({ ...config, [name]: value });
  };

  const clickHandler = () => {
    setRemainingDayConfig(config)
      .then((resp) => {
        toast.success(resp.msg);
        props.onSuccess();
        props.onClose();
      })
      .catch(packetErrorHandler);
  };

  return (
    <>
      <Form className="!w-80 gap-3 py-8 px-2 !mx-auto">
        <div className="flex w-full items-center ">
          <span className="text-sm text-gray-500 w-72">
            شروع روز تا سر رسید
          </span>
          <TextInput
            label=""
            name="startRemaingDay"
            onChange={changeHandler}
            value={config?.startRemaingDay?.toString() || ""}
            kind="percent"
            extraLabel
          />
        </div>
        <div className="flex w-full items-center ">
          <span className="text-sm text-gray-500 w-72">
            پایان روز تا سررسید
          </span>
          <TextInput
            label=""
            name="endRemainingDay"
            onChange={changeHandler}
            value={config?.endRemainingDay?.toString() || ""}
            kind="percent"
            extraLabel
          />
        </div>
        <div className="flex w-full items-center ">
          <span className="text-sm text-gray-500 w-72">پله یک روز (%)</span>
          <TextInput
            label=""
            name="oneDayStepPercentage"
            onChange={changeHandler}
            value={config?.oneDayStepPercentage?.toString() || ""}
            kind="percent"
            extraLabel
          />
        </div>
      </Form>
      <div className="mt-6 mx-10">
        <Button text="ثبت" onClick={clickHandler} variant="contained" />
      </div>
    </>
  );
};

export default RemainingDayConfigModal;
